import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Button,
  TextField,
  Box,
  Alert,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CSVLink } from "react-csv";
import { getRequest } from "../../globalhelper/helper";
// import NewDynamicTable from "./NewDynamicTable";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../redux/Common/commonActions";
import NewDynamicTable from "../Edureka/NewDynamicTable";

const MSMEEmail = () => {
  const dispatch = useDispatch();

  const [Companies, setCompanies] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [openEmail, setOpenEmail] = useState(false);
  const [openEmailPopup, setOpenEmailPopup] = useState(false);

  const [formData, setFormData] = useState({
    company: ""
  });

  useEffect(() => {
    getRequest("api/edureka/getCompanyAssignedToUser")
      .then(({ res }) => {
        setCompanies(res.data || []);
      })
      .catch(console.error);
  }, []);

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    dispatch(showLoader());

    getRequest(
      `api/edureka/getMSMEEmailData?company=${formData.company?.orgid}`
    )
      .then(({ res }) => {
        setTableData(res.data || []);
      })
      .finally(() => dispatch(hideLoader()));
  };

  const handleReset = () => {
    setFormData({
      company: ""
    });

    setTableData([]);
  };

  const columnsWithAction = tableData.map(row => ({
    ...row,
    Action: "View Email"
  }));

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Search</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Autocomplete
                size="small"
                value={formData.company}
                options={Companies}
                getOptionLabel={option => option?.orgname || ""}
                onChange={(e, value) =>
                  handleChange("company", value)
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Company"
                  />
                )}
              />
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={!formData.company}
              >
                Submit
              </Button>

              <Button
                color="error"
                variant="contained"
                sx={{ ml: 1 }}
                onClick={handleReset}
              >
                Reset
              </Button>

              {tableData.length > 0 && (
                <Button
                  color="success"
                  variant="contained"
                  sx={{ ml: 1 }}
                >
                  <CSVLink
                    data={tableData}
                    filename="MSME_Email_Report.csv"
                    style={{
                      color: "white",
                      textDecoration: "none"
                    }}
                  >
                    Download
                  </CSVLink>
                </Button>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {tableData.length > 0 ? (
<TableContainer component={Paper} sx={{ mt: 2 }}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Sender Name</TableCell>
        <TableCell>Email Type</TableCell>
        <TableCell>Email Date</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Action</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {tableData.map((row, index) => (
        <TableRow key={index}>
          <TableCell>{row.sendername}</TableCell>
          <TableCell>{row.email_type}</TableCell>
          <TableCell>{row.email_date}</TableCell>
          <TableCell>{row.status}</TableCell>

          <TableCell>
            <Button
              variant="contained"
              size="small"
              sx={{
                minWidth: "90px",
                height: "30px",
                fontSize: "12px",
                padding: "4px 10px"
              }}

              onClick={() => setOpenEmail(true)}
            >
              View Email
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>
      ) : (
        <Box sx={{ mt: 2 }}>
          <Alert severity="warning">
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display.
          </Alert>
        </Box>
      )}

      <Dialog
        open={openEmail}
        maxWidth="md"
        fullWidth
        onClose={() => setOpenEmail(false)}
      >
        <DialogTitle>
          MSME Email Content
        </DialogTitle>

        <DialogContent dividers>
        <Typography paragraph>
            Dear Vendor,
        </Typography>

        <Typography paragraph>
            As part of our periodic vendor compliance review process,
            we request you to reconfirm your MSME/Udyam Registration
            status and provide the latest supporting documents,
            if applicable.
        </Typography>

        <Typography paragraph>
            Please review and share the following details:
        </Typography>

        <ul>
            <li>MSME/Udyam Registration Number</li>
            <li>Valid Udyam Registration Certificate</li>
            <li>Registered Business Name</li>
            <li>PAN Number</li>
            <li>GSTIN</li>
            <li>Contact Details (if updated)</li>
        </ul>

        <Typography paragraph>
            Kindly submit the required information within 7 business days
            to ensure our vendor records remain current and accurate.
        </Typography>

        <Typography paragraph>
            If there are no changes to your MSME registration details,
            please confirm the same by replying to this email.
        </Typography>

        <Typography paragraph>
            Thank you for your cooperation.
        </Typography>

        <Typography>
            Regards,
            <br />
            Demo Industrial Works Pvt Ltd Team
        </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenEmail(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MSMEEmail;